module.exports = __webpack_public_path__ + "img/university_7.762b2702.png";